// Export utilities for CSV and PDF
export const exportToCSV = (data, filename) => {
  // Convert dashboard data to CSV format
  const rows = [];
  
  // Summary Section
  rows.push('Summary');
  rows.push('Metric,Value');
  rows.push(`Gross Sales,${data.summary.gross}`);
  rows.push(`Tax,${data.summary.tax}`);
  rows.push(`Delivery Charges,${data.summary.deliveryCharges}`);
  rows.push(`Discount,${data.summary.discount}`);
  rows.push(`FOC Amount,${data.summary.focAmount}`);
  rows.push(`Sale Return Amount,${data.summary.saleReturnAmount}`);
  rows.push(`Net Sale,${data.summary.netSale}`);
  rows.push(`Total Orders,${data.summary.totalOrders}`);
  rows.push('');
  
  // Order Sources
  rows.push('Order Sources');
  rows.push('Source,Orders,Sales,Percentage');
  data.orderSources.forEach((source) => {
    rows.push(`${source.name},${source.orders},${source.sales},${source.percentage.toFixed(2)}%`);
  });
  rows.push('');
  
  // Payment Modes
  rows.push('Payment Modes');
  rows.push('Mode,Orders,Amount,Percentage');
  data.paymentModes.forEach((mode) => {
    rows.push(`${mode.name},${mode.orders},${mode.amount},${mode.percentage.toFixed(2)}%`);
  });
  rows.push('');
  
  // Order Types
  rows.push('Order Types');
  rows.push('Type,Orders,Sales,Avg Order');
  data.orderTypes.forEach((type) => {
    rows.push(`${type.name},${type.orders},${type.sales},${type.avgOrder.toFixed(2)}`);
  });
  rows.push('');
  
  // Waiter Performance
  if (data.waiterPerformance.length > 0) {
    rows.push('Waiter Performance');
    rows.push('Name,Orders,Sales,Avg Order,Rating');
    data.waiterPerformance.forEach((waiter) => {
      rows.push(`${waiter.name},${waiter.orders},${waiter.sales},${waiter.avgOrder.toFixed(2)},${waiter.rating}`);
    });
    rows.push('');
  }
  
  // Rider Performance
  if (data.riderPerformance.length > 0) {
    rows.push('Rider Performance');
    rows.push('Name,Orders,Sales,Avg Order,On Time %');
    data.riderPerformance.forEach((rider) => {
      rows.push(`${rider.name},${rider.orders},${rider.sales},${rider.avgOrder.toFixed(2)},${rider.onTime}%`);
    });
    rows.push('');
  }
  
  // Top Products
  if (data.topProducts && data.topProducts.length > 0) {
    rows.push('Top Products');
    rows.push('Category,Product,Quantity,Sales,Percentage');
    data.topProducts.forEach((product) => {
      rows.push(`${product.category},${product.product},${product.quantity},${product.sales},${product.percentage.toFixed(2)}%`);
    });
    rows.push('');
  }
  
  // Categories
  if (data.categories && data.categories.length > 0) {
    rows.push('Category Breakdown');
    rows.push('Category,Quantity,Sales,Percentage');
    data.categories.forEach((category) => {
      rows.push(`${category.name},${category.quantity},${category.sales},${category.percentage.toFixed(2)}%`);
    });
    rows.push('');
  }
  
  // Create CSV content
  const csvContent = rows.join('\n');
  
  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Export to Excel (CSV format compatible with Excel)
export const exportToExcel = (data, filename) => {
  exportToCSV(data, filename);
};

// Print function
export const printDashboard = () => {
  window.print();
};

// Get date range based on selection
export const getDateRangeFromSelection = (selection) => {
  const now = new Date();
  const endDate = new Date(now);
  let startDate = new Date(now);
  
  switch (selection) {
    case 'today':
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      break;
    case 'yesterday':
      startDate.setDate(now.getDate() - 1);
      startDate.setHours(0, 0, 0, 0);
      endDate.setDate(now.getDate() - 1);
      endDate.setHours(23, 59, 59, 999);
      break;
    case 'week':
      startDate.setDate(now.getDate() - now.getDay());
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      break;
    case 'month':
      startDate.setDate(1);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      break;
    default:
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
  }
  
  return { startDate, endDate };
};
